import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  FETCH_REVIEW_DETAIL,
  FETCH_REVIEW_LIST,
  MODIFY_REVIEW,
  SUBMIT_PRODUCT_REVIEW,
} from 'store/actionTypes';
import { postReviews, getReviewDetail, editReview, getReviews } from 'services';
import {
  submitProductReviewSuccess,
  submitProductReviewError,
  fetchReviewDetailSuccess,
  fetchReviewDetailError,
  modifyReviewSuccess,
  modifyReviewError,
  fetchReviewListSuccess,
  fetchReviewListError,
} from 'store/actions';

function* productReview({ payload }) {
  try {
    const response = yield call(postReviews, payload);
    if (!response.error) {
      yield put(submitProductReviewSuccess(response.data));
    } else {
      yield put(submitProductReviewError(response.message));
    }
  } catch (error) {
    yield put(submitProductReviewError(error));
  }
}

export function* watchProductReviews() {
  yield takeLatest(SUBMIT_PRODUCT_REVIEW, productReview);
}

function* userReviews({ payload }) {
  try {
    const response = yield call(getReviews, payload);
    if (!response.error) {
      yield put(
        fetchReviewListSuccess(response.data, {
          ...payload,
          total: response.totalCount,
        })
      );
    } else {
      yield put(fetchReviewListError(response.message));
    }
  } catch (error) {
    yield put(fetchReviewListError(error));
  }
}

export function* watchFetchUserReviews() {
  yield takeLatest(FETCH_REVIEW_LIST, userReviews);
}

function* fetchReviewItemDetail({ payload }) {
  try {
    const response = yield call(getReviewDetail, payload);

    if (!response.error) {
      yield put(fetchReviewDetailSuccess(response.data));
    } else {
      yield put(fetchReviewDetailError(response.message));
    }
  } catch (error) {
    yield put(fetchReviewDetailError(error));
  }
}

export function* watchFetchReviewDetail() {
  yield takeLatest(FETCH_REVIEW_DETAIL, fetchReviewItemDetail);
}

function* modifyReviewItem({ payload }) {
  try {
    const response = yield call(editReview, payload);
    if (!response.message) {
      yield put(modifyReviewSuccess(response.data));
    } else {
      yield put(modifyReviewError(response.message));
    }
  } catch (error) {
    yield put(modifyReviewError(error));
  }
}

export function* watchModifyReview() {
  yield takeLatest(MODIFY_REVIEW, modifyReviewItem);
}

export default function* rootSaga() {
  yield all([
    fork(watchProductReviews),
    fork(watchFetchUserReviews),
    fork(watchFetchReviewDetail),
    fork(watchModifyReview),
  ]);
}
